export function numeroALetras(number: number) {
    if (number == 0) return "cero";

    function nd(n: number, d: number) {
        const num = n % (d * 10);
        const dig = Math.floor(num / d);
        return [num, dig];
    }

    function c(n: number, d: number) {
        const cientos = Math.floor(n / d) % d;
        const resto = n % d;
        return [cientos, resto];
    }

    //1~999
    function unidades(n: number, last: boolean = false) {
        const [_, digito] = nd(n, 1);
        switch (digito) {
            case 1: return last ? "uno" : "un";
            case 2: return "dos";
            case 3: return "tres";
            case 4: return "cuatro";
            case 5: return "cinco";
            case 6: return "seis";
            case 7: return "siete";
            case 8: return "ocho";
            case 9: return "nueve";
            default: return "";
        }
    }

    function decenas(n: number, last: boolean = false) {
        const [decena, digito] = nd(n, 10);

        function decenaY(decenaName: string) {
            const [_, digito] = nd(decena, 1);
            return decenaName + (digito == 0 ? "" : " y " + unidades(n, last));
        }

        switch (digito) {
            case 1: switch (decena) {
                case 10: return "diez";
                case 11: return "once";
                case 12: return "doce";
                case 13: return "trece";
                case 14: return "catorce";
                case 15: return "quince";
                default: return "dieci" + unidades(decena, last);
            }
            case 2: switch (decena) {
                case 20: return "veinte";
                default: return "veinti" + unidades(decena, last);
            }
            case 3: return decenaY("treinta");
            case 4: return decenaY("cuarenta");
            case 5: return decenaY("cincuenta");
            case 6: return decenaY("sesenta");
            case 7: return decenaY("setenta");
            case 8: return decenaY("ochenta");
            case 9: return decenaY("noventa");
            default: return unidades(decena, last);
        }
    }

    function centenas(n: number, last: boolean = false) {
        const [centena, digito] = nd(n, 100);
        switch (digito) {
            case 1: return centena > 100 ? "ciento " + decenas(centena, last) : "cien";
            case 2: return "docientos " + decenas(centena, last);
            case 3: return "trescientos " + decenas(centena, last);
            case 4: return "cuatrocientos " + decenas(centena, last);
            case 5: return "quinientos " + decenas(centena, last);
            case 6: return "seiscientos " + decenas(centena, last);
            case 7: return "setecientos " + decenas(centena, last);
            case 8: return "ochocientos " + decenas(centena, last);
            case 9: return "novecientos " + decenas(centena, last);
            default: return decenas(centena, last);
        }
    }

    //1000~999999
    function miles(n: number) {
        const [primeraCentena] = c(n, 1000);
        if (primeraCentena == 0) return centenas(n, true);
        if (primeraCentena == 1) return "mil " + centenas(n, true);
        return centenas(primeraCentena) + " mil " + centenas(n, true);
    }

    //1000000~999999999
    function millones(n: number) {
        const [primeraCentena] = c(n, 1000000);
        if (primeraCentena == 0) return miles(n);
        if (primeraCentena == 1) return "un millón " + miles(n);
        return centenas(primeraCentena) + " millones " + miles(n);
    }

    //1000000000~999999999999
    function billones(n: number) {
        const [primeraCentena] = c(n, 1000000000);
        if (primeraCentena == 0) return millones(n);
        if (primeraCentena == 1) return "un billón " + millones(n);
        return centenas(primeraCentena) + " billones " + millones(n);
    }

    const enteros = Math.floor(number);
    const decimal = Math.round((number - enteros) * 100);

    const hasEnteros = enteros > 0;
    const hasDecimal = decimal > 0;

    const enteroLetras = billones(enteros);
    const decimalLetras = billones(decimal) + " centavos";
    
    const letras = `${hasEnteros?enteroLetras:""}${hasEnteros&&hasDecimal?" con ":""}${hasDecimal?decimalLetras:""}`

    return letras;
}

export function capitalize(text: string) {
    const value = String(text);
    return value.charAt(0).toUpperCase() + value.slice(1);
}